import { useState } from "react";
import { isProd } from "./isProd";

const PAGE = isProd ? 25 : 15;

export const useLimit = (value?: number) => {
  const page = value ?? PAGE;
  const [limit, setLimit] = useState(page);

  const resetLimit = () => setLimit(page);

  const loadMore = () => setLimit(limit + page);

  return { limit, loadMore, resetLimit };
};
